import { Alert, AlertTitle, Box, Container, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, Navigate, Route, Routes, matchPath, useLocation, useParams } from 'react-router-dom';
import PowerBalancingMainPanel from '../../../panels/logistics/PowerBalancingMainPanel/PowerBalancingMainPanel';
import AdvicesPanel from '../../../panels/logistics/AdvicesPanel/AdvicesPanel';
import LogisticMapPanel from '../../../panels/logistics/LogisticMapPanel/LogisticMapPanel';
import { useAppSelector } from '../../../app/store';
import reducerPath from '../../../app/reducerPath';
import TextName from './styles/TextName';
import LogisticSocket from '../../../panels/logistics/PowerBalancingMainPanel/LogisticSocket';
import { logisticTasksBalanceResourceActions } from '../../../entities/logistic/logisticTasks/redux/logisticTasksBalance.slice';
import LogisticTaskActionButtons from '../../../features/logistics/LogiscticTaskActionButtons/LogiscticTaskActionButtons';
import BackToTasksButton from '../../../features/logistics/BackToTasksButton/BackToTasksButton';
import LogisticTaskBll from '../../../entities/logistic/logisticTasks/LogisticTaskBll/LogisticTaskBll';
import mapNames from '../../../entities/map/constants';
import { positionMapActions } from '../../../entities/map/positionMap/redux/positionMap.slice';
import { useLazyGetLogisticTaskIdQuery } from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';

function useRouteMatch(patterns) {
  const { pathname } = useLocation();
  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

function PowerBalancingMainRoutes() {
  return (
    <Routes>
      <Route path="" element={<PowerBalancingMainPanel />} />
    </Routes>
  );
}

const pageUrl = 'logistics/power-balancing';

const tabs = [
  { path: 'main', name: 'Балансировка мощностей', element: <PowerBalancingMainRoutes /> },
  { path: 'advices', name: 'Рекомендации', element: <AdvicesPanel /> },
  { path: 'map', name: 'Карта', element: <LogisticMapPanel /> },
];

const createRoute = (tabPath, id) => `/${pageUrl}/${id}/${tabPath}/*`;

// Отображает страницу "Балансировка мощностей"
function PowerBalancingView() {
  const params = useParams();
  const logisticTaskId = parseInt(params.logisticTaskId, 10);
  const routeMatch = useRouteMatch(tabs.map((tab) => createRoute(tab.path, logisticTaskId)));
  const currentTab = routeMatch?.pattern?.path;

  const dispatch = useDispatch();

  const mapName = mapNames.powerBalancing;

  const { data, stateData } = useAppSelector((state) => state[`${reducerPath.logisticTasksBalanceResource}/counter`]);
  const solutionUpdateTime = stateData?.stateMap?.solutionUpdateTime;

  const [getLogisticTask] = useLazyGetLogisticTaskIdQuery();

  useEffect(() => {
    if (!logisticTaskId || !solutionUpdateTime) return;

    getLogisticTask({ id: logisticTaskId });
  }, [solutionUpdateTime]);

  useEffect(() => {
    return () => {
      dispatch(logisticTasksBalanceResourceActions.resetState());
      dispatch(positionMapActions.resetView({ name: mapName }));
    };
  }, [dispatch]);

  if (Number.isNaN(logisticTaskId)) {
    return (
      <Alert severity="error" sx={{ margin: '30px' }}>
        <AlertTitle>Ошибка</AlertTitle>
        Задача логистики не определена
      </Alert>
    );
  }

  if (!currentTab) {
    return <Navigate to={tabs[0].path} />;
  }
  return (
    <LogisticSocket id={logisticTaskId}>
      <Container
        component="main"
        maxWidth="lg"
        sx={{
          paddingBottom: '40px',
          maxWidth: '100% !important',
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            pt: '20px',
            marginBottom: '10px',
          }}
        >
          <Tabs value={currentTab}>
            {tabs.map((tab) => (
              <Tab
                key={tab.path}
                label={tab.name}
                value={createRoute(tab.path, logisticTaskId)}
                to={tab.path}
                component={Link}
              />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <TextName>{data?.name}</TextName>
          <LogisticTaskBll logisticTaskId={logisticTaskId}>
            <LogisticTaskActionButtons />
          </LogisticTaskBll>
        </Box>
        <Routes>
          {tabs.map((tab) => (
            <Route key={tab.path} path={`${tab.path}/*`} element={tab.element} />
          ))}
        </Routes>
        <BackToTasksButton sx={{ display: 'flex', justifySelf: 'end', mt: 4 }} companyId={data?.companyId} />
      </Container>
    </LogisticSocket>
  );
}

export default PowerBalancingView;
